// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --survey-border-color: #DFE1E7;
    --survey-validation-error-color: #CE2C32;
    --survey-placeholder-color: #8E90A6;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/SurveyVars.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,wCAAwC;IACxC,mCAAmC;AACvC","sourcesContent":[":root {\n    --survey-border-color: #DFE1E7;\n    --survey-validation-error-color: #CE2C32;\n    --survey-placeholder-color: #8E90A6;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
